import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { getMe, isHttpStatus, type MeResponse } from "./api";

type Session =
  | { status: "loading" }
  | { status: "anonymous" }
  | { status: "unprovisioned" } // authenticated with Entra but no Learning Hub account
  | { status: "authed"; me: MeResponse };

const SessionContext = createContext<Session>({ status: "loading" });

export function SessionProvider({ children }: { children: ReactNode }) {
  const [session, setSession] = useState<Session>({ status: "loading" });

  useEffect(() => {
    let cancelled = false;
    getMe()
      .then((me) => !cancelled && setSession({ status: "authed", me }))
      .catch((err: unknown) => {
        if (cancelled) return;
        if (isHttpStatus(err, 401)) setSession({ status: "anonymous" });
        else if (isHttpStatus(err, 403)) setSession({ status: "unprovisioned" });
        else setSession({ status: "anonymous" });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return <SessionContext.Provider value={session}>{children}</SessionContext.Provider>;
}

export function useSession(): Session {
  return useContext(SessionContext);
}
